export class AdsServicesMarquee {
  constructor() {
    this.$marquee = document.getElementById("ads-services-marquee");
  }

  initMarquee = () => {
    const isMobile = window.innerWidth < 768;
    if (!this.$marquee) return;

    const originalItems = [...this.$marquee.children];
    let clonedItems = [];

    const updateClonedItems = () => {
      clonedItems.forEach((item) => item.remove());
      clonedItems = [];

      const listWidth = this.$marquee.getBoundingClientRect().width;
      const viewportWidth = window.innerWidth;
      const sets = Math.ceil(viewportWidth / listWidth) - 1;

      for (let i = 0; i < sets; i++) {
        const newClones = originalItems.map((item) => item.cloneNode(true));
        newClones.forEach((item) => this.$marquee.appendChild(item));
        clonedItems.push(...newClones);
      }

      const totalWidth = this.$marquee.scrollWidth;

      this.$marquee.style.setProperty("--marquee-duration", "60s");
      this.$marquee.style.setProperty("--marquee-distance", `-${totalWidth / 3}px`);
    };

    this.$marquee.addEventListener("mouseenter", () => {
      this.$marquee.style.animationPlayState = "paused";
    });

    this.$marquee.addEventListener("mouseleave", () => {
      this.$marquee.style.animationPlayState = "running";
    });

    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(updateClonedItems, 250);
    });

    updateClonedItems();
  };
}
